import React from 'react';
import { startCase } from 'lodash';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/site/items';

const ListItems = () => {
  const filter = {};

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        sort: { createdAt: -1 },
        filter,
        cols: [
          {
            key: 'active',
            getter(v) {
              return <FA icon={v ? faEye : faEyeSlash} />;
            },
          },
          { key: 'name', sortable: true, children: 'Name' },
          {
            key: 'description',
            sortable: true,
            children: 'Description',
          },
          { key: 'type', sortable: true, getter: (v) => startCase(v) },
          { key: 'subType', sortable: true, getter: (v) => startCase(v) },
          { key: 'price.dge', sortable: true, children: 'DGE' },
          { key: 'price.gxe', sortable: true, children: 'GXE' },
        ],
      }}>
    </ListResource>
  );
};

export default ListItems;
